import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=bf4ce8b8&scoped=true&"
import script from "./Points.vue?vue&type=script&lang=js&"
export * from "./Points.vue?vue&type=script&lang=js&"
import style0 from "./Points.vue?vue&type=style&index=0&id=bf4ce8b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4ce8b8",
  null
  
)

export default component.exports